import {useApi} from '@composables/useApi';
import {defineStore} from 'pinia';
import {FailedAuthError, KeysInfo} from "@store/api/interfaces";
import {useAuthApi} from "@store/api/authApi";
//import * as Sentry from "@sentry/vue";

export const useKeyApi = defineStore('keyApi', () => {
	const authApi = useAuthApi();

	const getList = async (): Promise<KeysInfo> => {
		try {
			return await useApi<KeysInfo>('/key', {
				method: "GET",
				headers: authApi.methods.getAuthHeaders()
			});
		} catch (error: any) {
			console.error('Failed get keys', error);
			//Sentry.captureException(error);
			throw new FailedAuthError(error.message);
		}
	}

	return {
		getList
	};
})
